import entrada1 from "./entrada1.jpeg"
import entrada2 from "./entrada2.jpeg"
import sala1 from "./sala1.jpeg"
import sala2 from "./sala2.jpeg"
import sala3 from "./sala3.jpeg"
import cozinha1 from "./cozinha1.jpeg"
import cozinha2 from "./cozinha2.jpeg"
import cozinha3 from "./cozinha3.jpeg"
import cozinha4 from "./cozinha4.jpeg"
import cozinha5 from "./cozinha5.jpeg"
import cozinha6 from "./cozinha6.jpeg"
import quarto1 from "./quarto1.jpeg"
import quarto2 from "./quarto2.jpeg"
import quarto3 from "./quarto3.jpeg"
import quarto4 from "./quarto4.jpeg"
import banheiro1 from "./banheiro1.jpeg"
import banheiro2 from "./banheiro2.jpeg"
import banheiro3 from "./banheiro3.jpeg"
import lavanderia from "./lavanderia.jpeg"

const ImagensAp2 = [
  entrada1,
  entrada2,
  sala1,
  sala2,
  sala3,
  cozinha1,
  cozinha2,
  cozinha3,
  cozinha4,
  cozinha5,
  cozinha6,
  quarto1,
  quarto2,
  quarto3,
  quarto4,
  banheiro1,
  banheiro2,
  banheiro3,
  lavanderia,
  ];

  export default ImagensAp2;